import React from 'react';
import {
  ArrowTopRightOnSquareIcon,
  AcademicCapIcon,
  BriefcaseIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const ProfessionalSummary = ({ about }) => {
  const highlights = [
    'Design and maintain AWS-based platforms using infrastructure as code and repeatable deployment patterns.',
    'Improve delivery workflows with CI/CD, automation, monitoring, and operational documentation.',
    'Apply practical security controls across IAM, networking, containers, and cloud-hosted applications.',
  ];

  return (
    <section className="bg-dark-800 py-16 border-t border-dark-700">
      <div className="container mx-auto max-w-7xl px-4">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.15fr_0.85fr]">
          <div>
            <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-primary-300">
              Professional Summary
            </p>
            <h2 className="text-3xl font-bold text-white">Cloud & DevOps Profile</h2>
            <p className="mt-4 max-w-3xl text-lg leading-8 text-gray-300">
              {about?.summary}
            </p>

            <div className="mt-8 space-y-4">
              {highlights.map((highlight) => (
                <div key={highlight} className="flex gap-3">
                  <CheckCircleIcon className="mt-1 h-5 w-5 flex-none text-primary-400" />
                  <p className="text-gray-300">{highlight}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <div className="rounded-lg border border-dark-600 bg-dark-900 p-6">
              <div className="flex items-center gap-3">
                <BriefcaseIcon className="h-7 w-7 text-primary-400" />
                <h3 className="text-xl font-bold text-white">Current Focus</h3>
              </div>
              <dl className="mt-5 space-y-4 text-sm">
                <div>
                  <dt className="font-semibold text-gray-200">Primary Areas</dt>
                  <dd className="mt-1 text-gray-400">AWS, Terraform, CI/CD, platform automation, and operational reliability.</dd>
                </div>
                <div>
                  <dt className="font-semibold text-gray-200">Recent Credentials</dt>
                  <dd className="mt-1 text-gray-400">AWS Agentic AI, Application Networking, Serverless, SysOps, Cloud Practitioner.</dd>
                </div>
              </dl>
            </div>

            <a
              href={about?.aws_training || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="block rounded-lg border border-primary-500/40 bg-primary-500/10 p-6 transition-colors hover:border-primary-400 hover:bg-primary-500/15"
            >
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center gap-3">
                  <AcademicCapIcon className="h-7 w-7 text-primary-300" />
                  <div>
                    <p className="text-sm font-semibold uppercase tracking-wide text-primary-300">Active Training</p>
                    <h3 className="mt-1 text-lg font-bold text-white">AWS Builder Labs</h3>
                  </div>
                </div>
                <ArrowTopRightOnSquareIcon className="h-5 w-5 flex-none text-primary-300" />
              </div>
              <p className="mt-4 text-sm leading-6 text-gray-300">
                Ongoing hands-on AWS training and lab work through AWS Skill Builder.
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfessionalSummary;
